import React, {useRef , useState} from 'react';
import { Form, Field } from 'react-final-form';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import { Toast } from 'primereact/toast';
import {contacterActif} from '../../Data/actif_service.js'
import FileUploader from '../NousContacter/FileUploader.jsx'
import "../NousContacter/FileUploader.css"

export default function NousContacter({setDialog, selectedActif}) {
const [file, setFile] = useState(null);
const toast = useRef(null);
    const onSubmit = async (data) => {
        const actifId  =selectedActif.id_actif_gexpertise;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("contenu", data.contenu);
        formData.append("objet", data.objet);
        //console.log('Sending POST request to:', `/api/actifs/${actifId}/formulaire/information`);
//console.log('Data:', data);   
         
        contacterActif(actifId,formData)  
        .then(() => {
          toast.current?.show({ 
              severity: 'success', 
              summary: 'succès', 
              detail: 'Votre demande a été envoyée avec succès', 
              life: 1000 
          });
          setTimeout(() => {
              setDialog(false);
          }, 1000);
      })
      .catch((error) => {
          console.error(error);
          toast.current.show({
              severity: 'error',
              summary: 'Erreur',
              detail: 'Une erreur s\'est produite lors de l\'envoi de votre demande.',
              life: 2000
          });
      });
     }
      
    const validate = (data) => {
        let errors = {};

        if (!data.objet) {
            errors.objet = 'Ce champ est obligatoire.'
        }
        if (!data.contenu) {
            errors.contenu = 'Ce champ est obligatoire.'
        }

        return errors;
    };

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta) => {
        return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
    };

    return (
        <>
        <Toast ref={toast} />
        <div className="toolBar_header">
            <Form onSubmit={onSubmit} initialValues={{ objet: `demande d'information sur l'actif: ${selectedActif.nom}`, contenu: ''}} validate={validate} render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="p-fluid">


                    <Field name="objet" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputText id="objet" {...input}  autoFocus  className={classNames({ 'p-invalid': isFormFieldValid(meta) })} />
                                <label htmlFor="objet" >Objet *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                    <Field name="contenu" render={({ input, meta }) => (
                        <div className="p-field">
                            <span className="p-float-label p-input-icon-right">

                                <InputTextarea id="Contenu" {...input} className={classNames({ 'p-invalid': isFormFieldValid(meta) })} autoResize />
                                <label htmlFor="Contenu" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Écrivez ici *</label>
                            </span>
                            {getFormErrorMessage(meta)}
                        </div>
                    )} />
                    {/* <label className="fileInput">
                <Field
                  name="file"
                  render={({ input, meta }) => (
                    <div className="p-field">
                      <input
                        type="file"
                        id="file"
                        onChange={
                          (e) => setFile(e.target.files[0])
                          // console.log('fileee' , e.target.files[0])
                        }
                      />
                      {meta.error && meta.touched && <span>{meta.error}</span>}
                    </div>
                  )}
                />{" "}
                <i className="pi pi-cloud-upload" style={{ fontSize: "15px" }}>
                  {" "}
                </i>{" "}
                Joindre un fichier
              </label> */}
              <FileUploader
                onFileChange={(selectedFile) => setFile(selectedFile)}
                label="Joindre un fichier"
                maxSize={20} // 20 MB
              />
                    <div className='btnContact'>
                        
                        <Button type="submit" label="Envoyer" className="p-mt-2 send" />
                    </div>

                </form>
            )} />


        </div>
        </>
    )
}